import React, { useState } from "react";
import { Modal, Card, CardBody, CardHeader, Button } from "reactstrap";
import ConfigurationForm from "../../components/Configuration/ConfigurationForm";

const Configuration = () => {
    const [modal, setModal] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);

    const toggle = () => setModal(!modal);

    // Define configuration categories and their fields
    const configCategories = [
        {
            category: 'BOOKING',
            label: 'Booking Settings',
            description: 'Configure booking time slots and intervals',
            icon: 'bx bx-calendar',
            fields: [
                {
                    key: 'BOOKING_START_TIME',
                    label: 'Working Start Time',
                    type: 'time',
                    required: true,
                    placeholder: '09:00',
                    helpText: 'Set the start time for booking slots (HH:mm format)'
                },
                {
                    key: 'BOOKING_END_TIME',
                    label: 'Working End Time',
                    type: 'time',
                    required: true,
                    placeholder: '18:00',
                    helpText: 'Set the end time for booking slots (HH:mm format)',
                    validate: (value, formData) => {
                        const startTime = formData.BOOKING_START_TIME;
                        if (startTime && value <= startTime) {
                            return 'End time must be after start time';
                        }
                        return null;
                    }
                },
                {
                    key: 'BOOKING_SLOT_INTERVAL',
                    label: 'Slot Interval (minutes)',
                    type: 'number',
                    required: true,
                    placeholder: '30',
                    min: 1,
                    max: 480,
                    helpText: 'Duration of each booking slot in minutes (1-480)'
                }
            ]
        },
        // Future categories can be added here
        // {
        //     category: 'PAYMENT',
        //     label: 'Payment Settings',
        //     description: 'Configure payment gateway and options',
        //     icon: 'bx bx-credit-card',
        //     fields: [
        //         {
        //             key: 'PAYMENT_GATEWAY',
        //             label: 'Payment Gateway',
        //             type: 'select',
        //             required: true,
        //             options: [
        //                 { value: 'stripe', label: 'Stripe' },
        //                 { value: 'paypal', label: 'PayPal' }
        //             ]
        //         }
        //     ]
        // },
        // {
        //     category: 'NOTIFICATION',
        //     label: 'Notification Settings',
        //     description: 'Configure email and SMS notifications',
        //     icon: 'bx bx-bell',
        //     fields: [
        //         {
        //             key: 'NOTIFICATION_EMAIL',
        //             label: 'Admin Email',
        //             type: 'email',
        //             required: true
        //         }
        //     ]
        // }
    ];

    const handleConfigureClick = (categoryConfig) => {
        setSelectedCategory(categoryConfig);
        setModal(true);
    };

    return (
        <React.Fragment>
            {/* page-wrapper */}
            <div className="page-wrapper">
                {/* page-content-wrapper */}
                <div className="page-content-wrapper">
                    <div className="page-content">
                        {/* breadcrumb */}
                        <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                            <div className="ps-3">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb mb-0 p-0">
                                        <li className="breadcrumb-item">
                                            <a href="#">Settings</a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Configuration
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        {/* end breadcrumb */}

                        <div className="card">
                            <CardHeader>
                                <div className="card-title">
                                    <h6 className="mb-0 pt-2 brand-color">System Configuration</h6>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <p className="text-muted mb-4">
                                    Manage system-wide configuration settings. Click on a category to view and edit its settings.
                                </p>

                                <div className="row">
                                    {configCategories.map((categoryConfig) => (
                                        <div className="col-md-6 col-lg-4 mb-4" key={categoryConfig.category}>
                                            <Card className="h-100 border shadow-sm">
                                                <CardBody>
                                                    <div className="d-flex align-items-start mb-3">
                                                        <div className="flex-shrink-0">
                                                            <div
                                                                className="rounded-circle d-flex align-items-center justify-content-center"
                                                                style={{
                                                                    width: '48px',
                                                                    height: '48px',
                                                                    backgroundColor: '#f0f0f0'
                                                                }}
                                                            >
                                                                <i className={`${categoryConfig.icon} fs-4 text-primary`}></i>
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1 ms-3">
                                                            <h6 className="mb-1">{categoryConfig.label}</h6>
                                                            <p className="text-muted small mb-0">
                                                                {categoryConfig.description}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <Button
                                                        color="primary"
                                                        size="sm"
                                                        outline
                                                        className="w-100"
                                                        onClick={() => handleConfigureClick(categoryConfig)}
                                                    >
                                                        <i className="bx bx-cog me-1"></i>
                                                        Configure
                                                    </Button>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    ))}
                                </div>

                                {configCategories.length === 0 && (
                                    <div className="text-center py-5">
                                        <i className="bx bx-cog fs-1 text-muted"></i>
                                        <p className="text-muted mt-3">No configuration categories available</p>
                                    </div>
                                )}
                            </CardBody>
                        </div>

                        {/* Configuration Modal */}
                        {selectedCategory && (
                            <Modal isOpen={modal} toggle={toggle} size="lg">
                                <ConfigurationForm
                                    toggle={toggle}
                                    category={selectedCategory.category}
                                    categoryLabel={selectedCategory.label}
                                    configFields={selectedCategory.fields}
                                    getData={() => {
                                        // Optional: Refresh data if needed
                                        console.log('Configuration saved');
                                    }}
                                />
                            </Modal>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Configuration;
